import { Component, Signal, inject } from '@angular/core';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';
import { AppShieldAccessListsThreatItemComponent, ShieldAccessListsApiStore, ShieldAccessListsStoreType } from '@bn/app-shield';
import { AppShieldActionPrecedenceComponent } from '@bn/app-shield/pages/app-shield-access-lists/components/app-shield-action-precedence-component/app-shield-action-precedence-component';
import { AbstractLazyDirective } from '@bn/shared/entities/abstracts/abstract-lazy.directive';
import { StoreRequest } from '@bn/shared/state-store';
import { BadgeComponent } from '@bn/web-ui/badge/badge.component';
import { CardComponent } from '@bn/web-ui/card/card.component';
import { NotAvailableComponent } from '@bn/web-ui/not-available/not-available-component/not-available.component';

@Component({
  templateUrl: './app-shield-access-lists-custom.page.html',
  imports: [
    BadgeComponent,
    AppShieldAccessListsThreatItemComponent,
    AppShieldActionPrecedenceComponent,
    CardComponent,
    NotAvailableComponent,
    NgxSkeletonLoaderComponent,
  ],
})
export class AppShieldAccessListsCustomPage extends AbstractLazyDirective {
  readonly #shieldAccessListsStore = inject(ShieldAccessListsApiStore);

  readonly isLoading = this.#shieldAccessListsStore.isLoading(StoreRequest.List);
  readonly storeCustomList = this.#shieldAccessListsStore.customLists as Signal<ShieldAccessListsStoreType['customLists']>;
  readonly customEntryCount = this.#shieldAccessListsStore.customEntryCount;
  readonly customEntryLimit = this.#shieldAccessListsStore.customEntryLimit;
  readonly customListCount = this.#shieldAccessListsStore.customListCount;
  readonly customListLimit = this.#shieldAccessListsStore.customListLimit;
}
